import i18n from '../../lib/i18n';

const czkCurrency = (value) => {
  if (value === 0) {
    return i18n.t('free');
  }
  return new Intl.NumberFormat(i18n.locale, {
    style: 'currency',
    currency: 'CZK',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

const eurCurrency = (value) => {
  if (value === 0) {
    return i18n.t('free');
  }
  return new Intl.NumberFormat(i18n.locale, {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export function currency(value) {
  if (i18n.locale === 'sk' || i18n.locale === 'en') {
    return eurCurrency(value);
  }

  if (i18n.locale === 'cs') {
    return czkCurrency(value);
  }

  return czkCurrency(value);
}
